import { render } from "./mensajeCookies.vue?vue&type=template&id=bc5ebc58"
import script from "./mensajeCookies.vue?vue&type=script&lang=js"
export * from "./mensajeCookies.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__